var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("v-progress-linear", {
        staticClass: "mb-1",
        attrs: {
          color: "primary",
          "background-color": "blue-grey lighten-3",
          height: "8",
          rounded: "",
          query: "",
        },
        model: {
          value: _vm.progressPercent,
          callback: function ($$v) {
            _vm.progressPercent = $$v
          },
          expression: "progressPercent",
        },
      }),
      _vm._v(" "),
      _vm.progressPercent == 100
        ? _c("div", { staticClass: "fs-12 green--text" }, [
            _vm._v(
              _vm._s(
                _vm.$t("congratulations_you_reached_the_minimum_order_amount")
              )
            ),
          ])
        : _c("div", { staticClass: "fs-12" }, [
            _vm._v(_vm._s(_vm.$t("you_need_to_reach")) + " "),
            _c("span", { staticClass: "fw-600" }, [
              _vm._v(_vm._s(_vm.format_price(_vm.minOrder))),
            ]),
            _vm._v(" " + _vm._s(_vm.$t("to_place_order_from_this_shop"))),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }